import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-colored-spinner',
  templateUrl: './colored-spinner.component.html',
  styleUrls: ['./colored-spinner.component.scss']
})
export class ColoredSpinnerComponent {
}
